import React from "react"

export const defaultGlobalState = {
	// Shell
	stores: {},
	shop: "",
	accessToken: null,
	userId: null,
	userEmail: null,
	hasCompletedOnBoarding: false,
	storeNames: {},
	staffForStores: [],
	storeOwners: {},
	savedStores: [],
	// Billing
	loadingIsSubbed: true,
	paddleCustomerId: null,
	hasValidKopyBasicSubscription: false,
	kopyBasicSubscription: null,
	hasTrialedKopyBasicBefore: null,
	otherKopyBasicSubscriptions: [],
	hasValidKopyPlusSubscription: false,
	kopyPlusSubscription: null,
	hasTrialedKopyPlusBefore: null,
	hasValidKopyProtectSubscription: false,
	kopyProtectSubscription: null,
	hasTrialedKopyProtectBefore: null,
	otherKopyProtectSubscriptions: [],
	pricing: {},
	discounts: {},
	customerAuthToken: null,
	hasAnyStoreSubscriptions: false,
	hasAnyUnlinkedStoreSubscriptions: false,
	subscriptionLookupFailed: false,
	// Store Data
	isCurrencyFetched: false,
	shopCurrency: "",
	storeLanguage: "en",
	availableStoreLanguages: ["en"],
	storeThemes: [],
	// User/Store Data
	loadingUserData: true,
	defaultTags: [],
	publishByDefault: false,
	statusActiveByDefault: true,
	roundingEnabledByDefault: false,
	roundingNumberByDefault: null,
	defaultVendor: "",
	taxableByDefault: true,
	skipDuplicates: true,
	disableCurrencyConversion: false,
	defaultTranslateLanguage: null,
	// Tracking
	hasTutorialDismissed: false,
	hasImportedAProduct: false,
	hasDismissedReviewBanner: false,
	hasDismissedAdBannerBlokyWide: false,
	hasDismissedAdBannerJustupsellWide: false,
	hasReadLatestChanges: true,
	hasClosedAdDrawer: false,
	hasClosedFeedback: false,
	hasDismissedReimportTemplatesBanner: false,
	hasDismissedKopyPlusCTA: false,
	hasClosedScrollingSwapPromo: false,
	hasTrialedFromEmailOfferBefore: false,
	hasNotTrialedFromEmailOfferAndUrlIsFromEmailOffer: false,
	// App Id for Kopy Protect
	appId: null,
	// Scopes for published field
	currentScopes: [],
}

export const GlobalStateContext = React.createContext(defaultGlobalState)

export const GlobalStateProvider = ({ children }) => {
	const [state, dispatch] = React.useReducer((state, newValue) => {
		if ("disableCurrencyConversion" in newValue) {
			window.kopy_disableCurrencyConversion =
				newValue.disableCurrencyConversion
		}

		return {
			...state,
			...newValue,
		}
	}, defaultGlobalState)

	return (
		<GlobalStateContext.Provider value={{ state, dispatch }}>
			{children}
		</GlobalStateContext.Provider>
	)
}
